<script setup>
import { Head, Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue'
</script>

<script>
export default {
    mounted(){
        document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-1.jpg') + '")';
        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';
    }
}
</script>

<template>
    <AppLayout title="About Inspire Properties" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Company</a></li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">About</h2>
            </div>
        </template>

        <section class="about-us">
            <div class="about-us-top pt-2 pt-lg-auto">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6 ps-lg-5 px-auto">
                                <div class="headings d-lg-none pb-4">
                                    <h2>
                                        About Us
                                    </h2>
                                </div>
                                <div class="img-container">
                                    <figure>
                                        <img :src="asset('/images/homepage/what-we-do/about-us-image.jpg')">
                                    </figure>
                                </div>
                            </div>
                            <div class="col-lg-6 pe-lg-5 px-auto">
                            <div class="headings">
                                <h2 class="d-none d-lg-block">
                                    About Us
                                </h2>
                                <p>
                                    Inspire Properties is a Luxury Real Estate company based in Dubai. Distinguished by the principle of trust, we are very proud of the legacy we have
                                    created in a short span of time. Our emphasis on the virtues of competence, transparency and moral conduct enables us to build and maintain
                                    unwavering trust from all of our clients. Every penny that our clients invest is an added ounce of responsibility that we accept and endure.
                                    Our team of agents work in a culture that thrives on information exchange, market studies and informed guidance to all our clients.
                                </p>
                            </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="stats">
                <div class="container">
                  <div class="row">
                     <div class="col-lg-4">
                        <div class="stats-wrapper">
                            <div class="stats-count">
                                <h2>17 +</h2>
                                <p>Years Of<span class="d-block">
                                   Experience
                                </span></p>
                            </div>
                        </div>
                     </div>
                      <div class="col-lg-4">
                        <div class="stats-wrapper center">
                             <div class="stats-count">
                                <h2>7.84M +</h2>
                                <p>Sq. Ft.<span class="d-block">
                                    Transacted
                                </span></p>
                            </div>
                        </div>
                     </div>
                      <div class="col-lg-4">
                        <div class="stats-wrapper">
                             <div class="stats-count">
                                <h2>1.24B +</h2>
                                <p>Value<span class="d-block">
                                   Closed
                                </span></p>
                            </div>
                        </div>
                     </div>
                  </div>
                </div>
            </div>
        </section>
         <section class="our-values">
            <div class="container-fluid px-lg-0">
                <div class="row align-items-center px-lg-0 mx-lg-0">
                    <div class="col-lg-6 px-0">
                        <div class="assets-img">
                            <figure class="mb-0">
                                <img :src="asset('/images/about/our-achievements.jpg')" alt="Our Achievements">
                            </figure>
                        </div>
                    </div>
                    <div class="col-lg-6 mt-5 mt-lg-0  ps-5">
                        <div class="current-assets-content">
                            <div class="headings">
                                <h2>Virtues We Strive For</h2>
                                <div class="accordion mt-4" id="accordionPanelsStayOpenExample">
                                    <div class="accordion-item">
                                        <!-- data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="false" aria-controls="panelsStayOpen-collapseOne" -->
                                        <button class="accordion-button collapsed no-icon" type="button" style="cursor: default !important">
                                           <span>01.</span> COMPETENCE
                                        </button>
                                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingOne">
                                            <div class="accordion-body">
                                                <p>Short description here. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec rutrum congue leo eget malesuada.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <!-- data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo" -->
                                        <button class="accordion-button collapsed no-icon" type="button" style="cursor: default !important">
                                             <span>02.</span> TRANSPARENCY
                                        </button>
                                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                            <div class="accordion-body">
                                                <p>Short description here. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec rutrum congue leo eget malesuada.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <!-- data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree" -->
                                        <button class="accordion-button collapsed no-icon" type="button" style="cursor: default !important">
                                            <span>03.</span> RESPONSIBILITY
                                        </button>
                                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                            <div class="accordion-body">
                                                <p>Short description here. Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec rutrum congue leo eget malesuada.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="mission-vision d-none">
          <div class="container">
              <div class="mission-vision-heading">
                  <div class="col-lg-7 mx-auto">
                      <div class="headings">
                         <h2>Our Mission and Vision</h2>
                      </div>
                  </div>
              </div>
             <div class="row mt-5">
               <div class="col-lg-6 pe-lg-4">
                 <div class="image-container">
                    <figure>
                        <img :src="asset('/images/about/our-mission.jpg')" alt="our-mission">
                    </figure>
                 </div>
                 <div class="heading">
                     <h3>Our Mission</h3>
                 </div>
                 <h5 class="excerpt mt-2">Lorem ipsum dolor sit.</h5>
                 <p class="statement mt-3">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptatum quas minus, asperiores cupiditate aliquid maiores exercitationem? </p>
               </div>
                <div class="col-lg-6 mt-lg-0 mt-5">
                <div class="image-container">
                    <figure>
                        <img :src="asset('/images/about/our-vision.jpg')" alt="our-vision">
                    </figure>
                 </div>
                 <div class="heading">
                     <h3>Our Vision</h3>
                 </div>
                 <h5 class="excerpt mt-2">Lorem ipsum dolor sit.</h5>
                 <p class="statement mt-3">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptatum quas minus, asperiores cupiditate aliquid maiores exercitationem? </p>
               </div>
             </div>
          </div>
        </section>
        <section class="teams">
           <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 ps-lg-5 px-auto">
                        <div class="img-container">
                            <figure>
                                <img width="150" :src="asset('/images/inspire-properties-savan.png')">
                            </figure>
                        </div>
                    </div>
                    <div class="col-md-6 pe-lg-5 px-auto mt-5">
                        <div class="team-member-info">
                                <figure class="mb-4 slider-quote"><img src="http://localhost:3000/images/homepage/testimonial/q.png" alt=""></figure>
                            <h5>
                                With a burning passion for real estate and Master’s Degree at Law from the U.K, Sawan first arrived in Dubai in 2005.
                                For last 17 years, he has spearheaded ventures in Real Estate, Developments, Trading, Retail And F&B. Having built
                                successful portfolio of businesses spanning GCC, Africa and India, his passion for creating and developing opportunities
                                is truly inspiring.
                            </h5>
                            <div class="member-info">
                                <h4 class="name">Sawan Ravani</h4>
                                <p>Founder | Inspire Properties </p>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center mt-5">
                        <div class="col-md-6 pe-lg-5 order-md-1 order-2 px-auto mt-5">
                            <div class="team-member-info">
                                <figure class="mb-4 slider-quote"><img src="http://localhost:3000/images/homepage/testimonial/q.png" alt=""></figure>
                            <h5>
                                16-year-old Deep found his purpose in life when he saw a family moving into the first apartment he had ever sold. From
                                running a family real estate firm with his father in Mumbai, India to managing Inspire Properties in Dubai, his journey
                                has been one of immense passion and satisfaction.
                            </h5>
                            <div class="member-info">
                                <h4 class="name">Deep Ruparelia</h4>
                                <p>CEO | Inspire Properties </p>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-6 ps-lg-5 order-md-2 order-1 px-auto">
                            <div class="img-container">
                                    <figure>
                                        <img width="150" :src="asset('/images/inspire-properties-deep.png')">
                                    </figure>
                                </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </AppLayout>
</template>

